import api from './api';

// Get all categories
export const getCategories = async () => {
    const response = await api.get('/categories');
    return response.data;
};

// Get category by ID
export const getCategory = async (id) => {
    const response = await api.get(`/categories/${id}`);
    return response.data;
};

// Create category (Super Admin only)
export const createCategory = async (categoryData) => {
    const response = await api.post('/categories', categoryData);
    return response.data;
};

// Update category (Super Admin only)
export const updateCategory = async (id, categoryData) => {
    const response = await api.put(`/categories/${id}`, categoryData);
    return response.data;
};

// Delete category (Super Admin only)
export const deleteCategory = async (id) => {
    const response = await api.delete(`/categories/${id}`);
    return response.data;
};

// Bulk delete categories (Super Admin only)
export const bulkDeleteCategories = async (categoriesIds) => {
    const response = await api.delete('/categories/bulk', {
        data: { ids: categoriesIds }
    });
    return response.data;
};